module.exports = __webpack_public_path__ + "img/i_boinovski.8a21b607.jpg";